(ns teamoesterreich.user-mode.prevent.prevent-help
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.user-mode.actions :as a]
    ))







(defn get-it []
  (fn []

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "stretch"
      :spacing    1
      }

     [mui/grid
      {:container false
       :item      true
       :xs        12
       }
      ""]
     [mui/grid
      {:container false
       :item      true
       :lg        7
       :xs        11
       }

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "center"
        :spacing    3
        }

       [mui/grid
        {:container false
         :item      true
         :lg        12
         :xs        12

         }
        [:br]
        [mui/card
         [mui/card-content
          [mui/typography {:variant "h4"} "Vorbereitung"]]
         [mui/typography {:variant "body1"}
          "Hier ist dein persönlicher Vorbereitungs-Assistent. Du kannst dich persönlich und deine Familie hier interaktiv und für deine Standorte vorbereiten."

          [:br] [:br]

          "Persönliche Checklisten zeigen dir, welche Maßnahmen du treffen kannst, geben dir viele Tipps und Hinweise und unter `Info` findest du weitere Informationen und hilfreiche Links."

          [:br] [:br]

          "Außerdem kannst du dir von hier aus fehlende Dinge auf deine Einkaufsliste und notwendige Maßnahmen auf die To-Do-Liste setzen."
          ]]
        ]

       ]



      [mui/grid
       {:container false
        :item      true
        :xs        6

        }

       [mui/button
        {:variant   "contained"
         :color     "primary"
         :class     "bottom-button"
         :onClick   (fn []
                      (a/set-user-details {:prep-enabled true})
                      (a/set-page :prevent-overview))
         :startIcon (r/as-element [keyboard-arrow-right])
         }
        "Weiter"]]

      ]]
    ))